import { getFullUrl } from 'hubspot-url-utils';
import PortalIdParser from 'PortalIdParser';
const PORTAL_ID = PortalIdParser.get();
export const userSettingsUrl = userId => `${getFullUrl('app')}/settings/${PORTAL_ID}/users/user/${userId}?tab=accessTab`;